import * as React from 'react';
import { colors } from '@styleseat/brand';

type ChevronIconProps = {
  width?: number;
  height?: number;
  color?: string;
  direction: 'up' | 'down' | 'right' | 'left';
  testID?: string;
} & React.SVGProps<SVGSVGElement>;

export const ChevronIcon = ({
  width,
  height,
  color,
  direction,
  testID,
  ...restProps
}: ChevronIconProps) => {
  let rotate = 0;
  if (direction === 'left') rotate = 90;
  if (direction === 'up') rotate = 180;
  if (direction === 'right') rotate = 270;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={testID}
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.862 0.861938L11.8048 1.80475L6.00005 7.60948L0.195312 1.80475L1.13812 0.861938L6.00005 5.72387L10.862 0.861938Z"
        fill={color}
        transform={`rotate(${rotate} 6 6) translate(0, 2) `}
      />
    </svg>
  );
};

ChevronIcon.defaultProps = {
  width: 12,
  height: 12,
  color: colors.blackInBlack,
};

export default ChevronIcon;
